export const ENTITY_TYPES = [
  "Individual",
  "Organization",
  "Vessel",
  "Aircraft",
  "Country",
  "Media",
] as const;
export type EntityType = (typeof ENTITY_TYPES)[number];
